import { stack } from '../../data/site';

/*--------------------
* Stack Section
----------------------*/
export default function SkillList() {
  return (
    <section id="stack" className="section">
      <div className="container">
        <div className="reveal max-w-[720px]">
          <span className="kicker">Toolkit</span>
          <h2 className="section-title mt-4">The stack I reach for.</h2>
          <p className="lede mt-5">
            Deep on React Native and TypeScript, current on the AI tooling that&rsquo;s
            reshaping what a mobile app can do.
          </p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:mt-16">
          {stack.map((group, i) => (
            <div
              key={group.group}
              className="reveal glass glass-hover card-sheen p-6 lg:p-7"
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="font-display text-[18px] font-[600] tracking-[-.01em] text-chalk">
                  {group.group}
                </h3>
                <span className="font-mono text-[11px] tracking-[.14em] text-tint/45">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>

              <div className="hairline my-5" />

              <ul className="flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <li key={item} className="chip">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
